import { render, staticRenderFns } from "./WBundleDialog.vue?vue&type=template&id=538d6536&scoped=true&"
import script from "./WBundleDialog.vue?vue&type=script&lang=js&"
export * from "./WBundleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538d6536",
  null
  
)

export default component.exports